import { render } from "./ProductSales.vue?vue&type=template&id=789d5a94"
import script from "./ProductSales.vue?vue&type=script&lang=js"
export * from "./ProductSales.vue?vue&type=script&lang=js"

import "./ProductSales.vue?vue&type=style&index=0&id=789d5a94&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__